export const CREATOR_DETAIL_PAGE_CLASS_NAME =
  "relative bg-[#FFF8E8] overflow-x-hidden";

export const CREATOR_DETAIL_MAIN_CLASS_NAME =
  "flex flex-col items-center gap-6 px-4 pt-6 pb-16";

export const CREATOR_DETAIL_SECTION_CLASS_NAME = "w-full space-y-6";

export const CREATOR_FLOATING_ACTIONS_CLASS_NAME =
  "creator-floating-actions pointer-events-none fixed bottom-6 left-1/2 z-40 w-full max-w-[437px] -translate-x-1/2 px-4";

export const CREATOR_FLOATING_SECONDARY_ACTION_CLASS_NAME =
  "shrink-0 rounded-[8px] border-black bg-white p-[10px] shadow-[0px_4px_0px_0px_#000000] cursor-pointer";

export const CREATOR_FLOATING_PRIMARY_ACTION_CLASS_NAME =
  "min-w-0 flex-1 shadow-[0px_4px_0px_0px_#000000] bg-[#0D41E1] text-white border-black text-[16px] font-medium";

export const CREATOR_FLOATING_ACTIONS_CONTENT_CLASS_NAME = "pb-12";
